module.exports = __webpack_public_path__ + "img/166-8beb45.png";